import { useMutation } from '@tanstack/react-query';

type DeleteCompanyParams = {
  companyId: number;
};

export default function useDeleteCompany() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ companyId }: DeleteCompanyParams) => {
      const response = await fetch(`/agent/api/companies/${companyId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({}),
      });
      const data = await response.json();
      return data;
    },
  });
}
